import React, { Suspense } from 'react'
import TempEntry from 'components_v2/_entryPoints/TempEntry'

const ReferralShare = React.lazy(() =>
  import('components_v2/Referral/ReferralShare')
)

export const ReferralShareTempEntry = (props) => {
  return (
    <TempEntry
      user={props.user}
      loadUser
      mt='0px'
      pb='60px'
      controls={{ navbar: true, footer: true }}
    >
      <Suspense fallback=''>
        <ReferralShare {...props} />
      </Suspense>
    </TempEntry>
  )
}

export default ReferralShareTempEntry
